import { HubConnection, HubConnectionBuilder, IHttpConnectionOptions, MessageHeaders } from "@microsoft/signalr"
import { User } from "oidc-client"
import { IConfig } from "../types/IConfig";

const config = window.config as IConfig;

const signalRService = {
    connection: null as HubConnection | null,
  
    startConnection: (user: User) => {
      if (user) {
        const options: IHttpConnectionOptions = {
          headers: {
            Authorization: `Bearer ${user?.access_token}`,
            //'x-ms-client-principal-name': user?.profile?.email?.toLowerCase(),
          } as MessageHeaders,
        }
        signalRService.connection = new HubConnectionBuilder()
          .withUrl(`${config.bffRoot}api`, options)
          .build()
      } else {
        signalRService.connection = new HubConnectionBuilder()
          .withUrl(`${config.bffRoot}api`)
          .build()
      }
  
      signalRService.connection
        ?.start()
        .then(() => {
          console.log('SignalR connection established.')
        })
        .catch((err) => {
          console.error('Error starting SignalR connection:', err)
        })
    },
  
    onReceiveMessage: (callback: (message: any) => void) => {
      signalRService.connection?.on('newMessage', (message) => {
        callback(message)
      })
    },
  
    sendMessage: (user: string, message: string) => {
      signalRService.connection
        ?.invoke('SendMessage', user, message)
        .catch((err) => {
          console.error('Error sending message:', err)
        })
    },
  }
  
  export default signalRService